// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HnIV","title":"Header_title__1bmqJ","left":"Header_left__1us3y","clinicName":"Header_clinicName__3Dc0i"};